import { merge } from "lodash";
import { Payload } from ".";
import { AppDispatch } from "../../configureStore";
import execute from "../http/execute";
import failure from "../http/failure";
import { get } from "../http/request";
import success from "../http/success";
import { ThemeConfig } from "antd";
import { ConfigStepType } from "../../utils/configuration";

export type StepType = 'signature' | 'transcripts';

export interface ICustomization {
    logo?: string;
    favicon?: string;
    htmlTitle?: string;
    fontLink?: string;
    configuration?: ThemeConfig;
    noHeader?: boolean;
};

export interface FEInstitution {
    institutionId: string;
    name: string;
    customization: ICustomization;
    allowLogin: boolean;
    requireLast4Tin: boolean;
    services: ConfigStepType[];
}

export const defaultTheme: ThemeConfig = {
    token: {},
    components: {
        Layout: {
            headerBg: 'white',
        },
    },
}

export const GET_CONFIGURATION_REQUEST = 'configuration/GET_CONFIGURATION_REQUEST';
export const GET_CONFIGURATION_SUCCESS = 'configuration/GET_CONFIGURATION_SUCCESS';
export const GET_CONFIGURATION_FAILURE = 'configuration/GET_CONFIGURATION_FAILURE';

const initialState: {
    logo: string;
    noHeader: boolean;
    antdConfig: ThemeConfig;
    steps: ConfigStepType[];
    institution?: {
        name: string;
        institutionId: string;
        requireLast4Tin: boolean;
    }
} = {
    logo: '/logo.png',
    noHeader: true,
    antdConfig: defaultTheme,
    steps: [],
}

type ActionParams =
    | { type: typeof GET_CONFIGURATION_SUCCESS; data: FEInstitution; };

function reducer(state = initialState, action: ActionParams): typeof initialState {
    switch (action.type) {
        case GET_CONFIGURATION_SUCCESS:
            const cloned = structuredClone(state.antdConfig);
            return {
                ...state,
                logo: action.data.customization.logo ?? state.logo,
                antdConfig: merge(cloned, action.data.customization.configuration),
                steps: action.data.services,
                noHeader: action.data.customization.noHeader ?? false,
                institution: {
                    name: action.data.name,
                    institutionId: action.data.institutionId,
                    requireLast4Tin: action.data.requireLast4Tin ?? false,
                },
            };

        default: return state;
    }
}

export const getConfiguration = (payload: Payload<{ l: string; }>) => (dispatch: AppDispatch) => {
    dispatch({
        type: GET_CONFIGURATION_REQUEST,
        payload,
    });

    execute(get, '/configuration', payload.input, {})
        .then(success(dispatch, GET_CONFIGURATION_SUCCESS, payload))
        .catch(failure(dispatch, GET_CONFIGURATION_FAILURE, payload));
};

export default reducer;
